<confirmaciongenerica #appconfirmacion (ConfirmoUsuario)="ConfirmoUsuario($event)" [TextoSiMostrar]="'Aceptar'" [TextoNoMostrar]="'Cancelar'"></confirmaciongenerica>
<mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
<div class="row mt-5">
    <div class="d-flex justify-content-between">
        <div>
            <h2 class="titleppal">Actualización opción menu</h2>
            <div class="line">
                <div class="line2"></div>
            </div>
        </div>
        <div class="botoncerrar">
            <a type="button" (click)="CancelarRegistro()">
                <mat-icon aria-hidden="false">close</mat-icon>
            </a>
        </div>
    </div>

    <div [formGroup]="form" fxFlex="auto" fxLayout="row" class="pr-0 pl-0 mb-5" autocomplete="off">
        <div class="col-md-3 col-lg-3 col-12" *ngIf="!mostrarCargando">
            <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
                <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
                    <mat-checkbox class="checklist-leaf-node" [checked]="EstaSeleccionado(node.id)" (change)="CambiarSeleccionRegistro(node.id, $event)">
                        {{node.item}}
                    </mat-checkbox>
                </mat-tree-node>

                <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
                    <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.item">
                        <mat-icon class="mat-icon-rtl-mirror">
                            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                        </mat-icon>
                    </button>
                    <mat-checkbox [checked]="EstaSeleccionado(node.id)" (change)="CambiarSeleccionRegistro(node.id, $event)">
                        {{node.item}}
                    </mat-checkbox>
                </mat-tree-node>
            </mat-tree>
        </div>
        <div class="col-md-9 col-lg-9 col-12" *ngIf="!mostrarCargando">
            <div class="row">
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Grupo</mat-label>
                        <input matInput formControlName="grupo" autocomplete="off">
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Nombre</mat-label>
                        <input matInput formControlName="nombre" autocomplete="off">
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Orden</mat-label>
                        <input matInput formControlName="orden" autocomplete="off">
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Icono</mat-label>
                        <input matInput formControlName="icono" autocomplete="off">
                    </mat-form-field>
                </div>
            </div>
            <div class="d-flex justify-content-between">
                <div class="d-flex flex-column">
                    <mat-slide-toggle formControlName="activo" [disabled]="!TieneSeleccionado()">Activo</mat-slide-toggle>
                    <mat-slide-toggle formControlName="requiereAliado" [disabled]="!TieneSeleccionado()">Requiere aliado</mat-slide-toggle>
                    <mat-slide-toggle formControlName="requiereCanal" [disabled]="!TieneSeleccionado()">Requiere canal</mat-slide-toggle>
                </div>
                <div *ngIf="this.tamanoAppService.mostrarModoEscritorio && !mostrarCargando && TieneSeleccionado()">
                    <button mat-button class="botonguardardatos" (click)="GuardarRegistro()" [disabled]="mostrarCargando">
                        <div class="d-flex flex-row-reverse">
                            <mat-icon class="botonguardardatosicono">check_circle_outline</mat-icon>
                            <span class="botonguardardatostexto">Actualizar</span>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>